import { catchError, debounceTime, map, switchMap } from 'rxjs/operators';
import { ActionsObservable, ofType } from 'redux-observable';
import { Action } from 'redux-actions';
import { of } from 'rxjs';

import { AddressActions } from './address.actions';
import { getAddress, IGetAddress } from './address.service';

export const getAddress$ = (actions$: ActionsObservable<Action<IGetAddress>>) => {
  return actions$.pipe(
    ofType(AddressActions.GetAddress),
    debounceTime(300),
    switchMap(({ payload }) =>
      getAddress(payload).pipe(
        map((payload) => ({
          type: AddressActions.GetAddressSuccess,
          payload,
        })),
        catchError((err) =>
          of({
            type: AddressActions.GetAddressError,
            payload: err,
          }),
        ),
      ),
    ),
  );
};
